var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.kpi && !_vm.loading)?_c('app-kpiform',{attrs:{"parentObject":{
        kpi: this.kpi,
        KPIItemFull: this.KPIItemFull,
        KPIItemSelectionList: this.KPIItemSelectionList,
        KPICategoryList: this.KPICategoryList,
        list: this.list,
        roleName: this.roleName,
        staffData: this.staffData
    }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }